module.exports = __webpack_public_path__ + "static/bannerObject1-f3a8a78f3f576e96860c040fda13f22d.png";